import { ExclamationCircleOutlined } from '@ant-design/icons';
import { ModalComponent } from '@operations/shared';

interface DeleteCollectionModalProps {
    visible: boolean;
    onCancel: () => void;
    onConfirm: () => Promise<void>;
    loading?: boolean;
}

export default function DeleteCollectionModal({
    visible,
    onCancel,
    onConfirm,
    loading = false
}: DeleteCollectionModalProps) {
    const handleConfirm = async () => {
        await onConfirm();
    };

    return (
        <ModalComponent
            title="Delete Collection"
            visibleModal={visible}
            handleCloseModal={onCancel}
            handleAcceptModal={handleConfirm}
            loadingConfirm={loading}
            okText="Yes"
            cancelText="No"
            content={
                <>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', padding: '8px 0' }}>
                        <ExclamationCircleOutlined style={{ fontSize: '16px', color: '#faad14', marginTop: '5px' }} />
                        <p style={{ fontSize: '16px', textAlign: 'center' }}>
                            Are you sure you want to delete this collection? 
                            <br />
                            This will affect the invoice.
                        </p>
                    </div>
                </>
            }
        />
    );
}
